import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/auth/Login.vue"),
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: "/recuperar-senha",
    name: "ForgotPassword",
    component: () =>
      import(
        /* webpackChunkName: "forgot-password" */ "@/views/auth/ForgotPassword.vue"
      ),
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ "@/views/dashboard/Dashboard.vue"
      )
  },
  {
    path: "/usuarios",
    name: "Users",
    component: () =>
      import(/* webpackChunkName: "users" */ "@/views/user/Users.vue")
  },
  {
    path: "/usuarios/editar-usuario/:id",
    name: "UsersDetails",
    component: () =>
      import(
        /* webpackChunkName: "users-details" */ "@/views/user/UsersDetails.vue"
      )
  },
  {
    path: "/construtoras",
    name: "Companies",
    component: () =>
      import(
        /* webpackChunkName: "companies" */ "@/views/company/Companies.vue"
      )
  },
  {
    path: "/construtoras/:id",
    name: "CompaniesDetails",
    component: () =>
      import(
        /* webpackChunkName: "companies-details" */ "@/views/company/CompaniesDetails.vue"
      )
  },
  {
    path: "/empreendimentos/:id",
    name: "BuildingDetails",
    component: () =>
      import(
        /* webpackChunkName: "building-details" */ "@/views/building/BuildingDetails.vue"
      )
  },
  {
    path: "/empreendimento/adicionar",
    name: "AddBuilding",
    component: () =>
      import(
        /* webpackChunkName: "add-building" */ "@/views/building/AddBuilding.vue"
      )
  },
  {
    path: "/imoveis",
    name: "Properties",
    component: () =>
      import(
        /* webpackChunkName: "properties" */ "@/views/property/Properties.vue"
      )
  },
  {
    path: "/imoveis/novo",
    name: "NewProperties",
    component: () =>
      import(
        /* webpackChunkName: "new-properties" */ "@/views/property/NewProperties.vue"
      )
  },
  {
    path: "/imoveis/:id/editar",
    name: "EditProperties",
    component: () =>
      import(
        /* webpackChunkName: "edit-properties" */ "@/views/property/EditProperties.vue"
      )
  },
  {
    path: "/imoveis/:id",
    name: "DetailsProperties",
    component: () =>
      import(
        /* webpackChunkName: "details-properties" */ "@/views/property/DetailsProperties.vue"
      )
  },
  {
    path: "/corretores",
    name: "Realtors",
    component: () =>
      import(/* webpackChunkName: "realtors" */ "@/views/realtor/Realtors.vue")
  },
  {
    path: "/criar-corretor",
    name: "CreateRealtor",
    component: () =>
      import(
        /* webpackChunkName: "create-realtor" */ "@/views/realtor/CreateRealtor.vue"
      )
  },
  {
    path: "/corretores/:id",
    name: "RealtorDetails",
    component: () =>
      import(
        /* webpackChunkName: "realtor-details" */ "@/views/realtor/RealtorDetails.vue"
      )
  },
  {
    path: "/times/corretores/adicionar",
    name: "AddRealtor",
    component: () =>
      import(
        /* webpackChunkName: "add-realtor" */ "@/views/realtor/AddRealtor.vue"
      )
  },
  {
    path: "/leads",
    name: "Leads",
    component: () =>
      import(/* webpackChunkName: "leads" */ "@/views/leads/Leads.vue")
  },
  {
    path: "/leads/importacoes",
    name: "LeadImports",
    component: () =>
      import(
        /* webpackChunkName: "lead-imports" */ "@/views/leads/LeadImports.vue"
      )
  },
  {
    path: "/leads/:id",
    name: "LeadDetails",
    component: () =>
      import(
        /* webpackChunkName: "lead-details" */ "@/views/leads/LeadDetails.vue"
      )
  },
  {
    path: "/estados",
    name: "States",
    component: () =>
      import(/* webpackChunkName: "states" */ "@/views/region/States.vue")
  },
  {
    path: "/estados/:id",
    name: "StatesDetail",
    component: () =>
      import(
        /* webpackChunkName: "states-detail" */ "@/views/region/StatesDetail.vue"
      )
  },
  {
    path: "/recursos",
    name: "Resources",
    component: () =>
      import(
        /* webpackChunkName: "resources" */ "@/views/property/Resources.vue"
      )
  },
  {
    path: "/leads/arquivados",
    name: "ArchivedLeads",
    component: () =>
      import(
        /* webpackChunkName: "archived-leads" */ "@/views/leads/ArchivedLeads.vue"
      )
  },
  {
    path: "/posts",
    name: "Posts",
    component: () =>
      import(/* webpackChunkName: "posts" */ "@/views/blog/Posts.vue")
  },
  {
    path: "/post/:id",
    name: "PostDetail",
    component: () =>
      import(
        /* webpackChunkName: "post-detail" */ "@/views/blog/PostDetail.vue"
      )
  },
  {
    path: "/nova-postagem",
    name: "CreatePost",
    component: () =>
      import(
        /* webpackChunkName: "create-post" */ "@/views/blog/CreatePost.vue"
      )
  },
  {
    path: "/times",
    name: "Teams",
    component: () =>
      import(/* webpackChunkName: "teams" */ "@/views/team/Teams.vue")
  },
  {
    path: "/imobiliaria/:realEstateId/times/:id",
    name: "TeamDetails",
    component: () =>
      import(
        /* webpackChunkName: "team-details" */ "@/views/team/TeamDetails.vue"
      )
  },
  {
    path: "/imobiliarias",
    name: "RealEstate",
    component: () =>
      import(
        /* webpackChunkName: "real-estate" */ "@/views/real_estate/RealEstate.vue"
      )
  },
  {
    path: "/imobiliarias/:id",
    name: "RealEstateDetail",
    component: () =>
      import(
        /* webpackChunkName: "real-estate-detail" */ "@/views/real_estate/RealEstateDetail.vue"
      )
  },
  {
    path: "/leads/:id/historico",
    name: "LeadHistoric",
    component: () =>
      import(
        /* webpackChunkName: "lead-historic" */ "@/views/leads/LeadHistoric.vue"
      )
  },
  {
    path: "/configuracoes",
    name: "Settings",
    component: () =>
      import(/* webpackChunkName: "settings" */ "@/views/settings/Settings")
  },
  {
    path: "/realtor/:id/historico",
    name: "RealtorHistoric",
    component: () =>
      import(
        /* webpackChunkName: "realtor-historic" */ "@/views/realtor/RealtorHistoric.vue"
      )
  },
  {
    path: "/desafios",
    name: "Challenges",
    component: () =>
      import(
        /* webpackChunkName: "challenges" */ "@/views/challenge/Challenges.vue"
      )
  },
  {
    path: "/desafios/:id",
    name: "ChallengeDetails",
    component: () =>
      import(
        /* webpackChunkName: "challenge-details" */ "@/views/challenge/ChallengeDetails.vue"
      )
  },
  {
    path: "/desafio/novo",
    name: "NewChallenge",
    component: () =>
      import(
        /* webpackChunkName: "new-challenge" */ "@/views/challenge/CreateAndEditChallenge.vue"
      )
  },
  {
    path: "/desafios/:id/editar",
    name: "EditChallenge",
    component: () =>
      import(
        /* webpackChunkName: "edit-challenge" */ "@/views/challenge/CreateAndEditChallenge.vue"
      )
  },
  {
    path: "/ranking",
    name: "Ranking",
    component: () =>
      import(/* webpackChunkName: "ranking" */ "@/views/ranking/ranking.vue")
  },
  {
    path: "/ranking/:id",
    name: "RankingDetail",
    component: () =>
      import(
        /* webpackChunkName: "ranking-detail" */ "@/views/ranking/rankingDetail.vue"
      )
  },
  {
    path: "/material_apoio",
    name: "BuildingContent",
    component: () =>
      import(
        /* webpackChunkName: "building-content" */ "@/views/material/BuildingContent.vue"
      )
  },
  {
    path: "/material_apoio/novo",
    name: "CreateBuildingContent",
    component: () =>
      import(
        /* webpackChunkName: "create-building-content" */ "@/views/material/CreateBuildingContent.vue"
      )
  },
  {
    path: "/material_apoio/:id",
    name: "BuildingContentDetail",
    component: () =>
      import(
        /* webpackChunkName: "building-content-detail" */ "@/views/material/BuildingContentDetail.vue"
      )
  },
  {
    path: "/corretores/:id/logs",
    name: "Logs",
    component: () =>
      import(/* webpackChunkName: "logs" */ "@/views/realtor/Logs.vue")
  },
  {
    path: "/notificacao",
    name: "PushNotification",
    component: () =>
      import(
        /* webpackChunkName: "push-notification" */ "@/views/notification/pushNotification.vue"
      )
  },
  {
    path: "/recomendacao/leads",
    name: "RecommendationLeads",
    component: () =>
      import(
        /* webpackChunkName: "leads" */ "@/views/recommendation/RecommendationLeads.vue"
      )
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  linkExactActiveClass: "active"
});

router.beforeEach((to, from, next) => {
  const { allowAnonymous } = to.meta;
  let isLoggedIn = null;

  if (localStorage["imob-de-bolso-vuex"]) {
    isLoggedIn = !!JSON.parse(localStorage["imob-de-bolso-vuex"]).auth
      .access_token;
    let value = JSON.parse(localStorage.getItem("imob-de-bolso-vuex"));
    Vue.prototype.$vrm.setRoles(value.auth.currentUser.attributes.role);
  }

  // redirect to dashboard if user is logged in and the page is public
  if (isLoggedIn && allowAnonymous) {
    return next({ name: "Dashboard" });
  }

  // redirect to login page if user is not authenticated and the page is not public
  if (!isLoggedIn && !allowAnonymous) {
    return next({ name: "Login" });
  }

  next();
});

export default router;
